/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator>): InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator(), model);
        InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator>): InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorLambdaFunctionNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the Lambda function name
     */
    starts_with: string;

}
